<button
  mat-icon-button
  class="notification-bell-button group"
  [matMenuTriggerFor]="notificationsMenu"
  (click)="togglePanel()">
  <mat-icon
    class="transition-transform duration-300 group-hover:scale-110"
    [matBadge]="unreadCount"
    [matBadgeHidden]="unreadCount === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
    [attr.aria-hidden]="false">
    notifications
  </mat-icon>
</button>

<mat-menu #notificationsMenu="matMenu" class="notification-panel">
  <div class="notification-header" (click)="$event.stopPropagation()">
    <h3 class="text-lg font-semibold">Notificaciones</h3>
    @if (unreadCount > 0) {
      <button
        mat-button
        color="primary"
        (click)="markAllAsRead()">
        <mat-icon class="icon-size-5">done_all</mat-icon>
        <span class="ml-1">Marcar todas</span>
      </button>
    }
  </div>

  <div class="notification-content" (click)="$event.stopPropagation()">
    @if (notifications.length > 0) {
      @for (notification of notifications; track notification) {
        <div
          class="notification-item"
          [class.unread]="!notification.read_at"
          (click)="onNotificationClick(notification)">
          <div class="notification-icon text-hr-500">
            <mat-icon>{{ notification.icon || 'notifications' }}</mat-icon>
          </div>
          <div class="notification-body">
            <div class="notification-title">{{ notification.title }}</div>
            <div class="notification-message">{{ notification.message }}</div>
            <div class="notification-time">{{ getRelativeTime(notification.created_at) }}</div>
          </div>
          @if (!notification.read_at) {
            <div class="notification-indicator"></div>
          }
        </div>
      }
    } @else {
      <div class="no-notifications">
        <mat-icon class="icon-size-24 text-hint">notifications_none</mat-icon>
        <div class="mt-4 text-secondary">No tienes notificaciones</div>
      </div>
    }

  </div>

  <div class="notification-footer" (click)="$event.stopPropagation()">
    <button
      mat-button
      color="primary"
      class="w-full"
      (click)="viewAllNotifications()">
      Ver todas las notificaciones
    </button>
  </div>
</mat-menu>
